export const ACTION = 'action';
export const ITEMS = 'items';

/**
 * Check if a React element is an instance of ContentGroup.Action
 * @param {React.ReactElement} el An instance of ReactElement
 */
export function isAction(el) {
  return el.type && el.type.role === ACTION;
}

/**
 * Check if a React element is an instance of ContentGroup.Items
 * @param {React.ReactElement} el An instance of ReactElement
 */
export function isItems(el) {
  return el.type && el.type.role === ITEMS;
}
